module.exports = __webpack_public_path__ + "static/media/team.69846864.jpg";